import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useContactRelationshipListViewModel = ({ dependentType }) => {
  const [relationships, setRelationships] = useState([]);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const loadData = () => {
    stateManager.run(async () => {
      const response = await accountService.contactCategories.getByType({
        type: dependentType,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setRelationships(response.data);
      }
    });
  };

  const createRelationship = (data) => {
    stateManager.run(async () => {
      const { label } = data;
      const response = await accountService.contactCategories.create({
        type: dependentType,
        label,
        data: {
          label,
          dependentType,
        },
        toastMessageConfig: {
          success: {
            text: `Relationship was updated successfully.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        loadData();
      }
    });
  };

  const deleteRelationship = (data) => {
    stateManager.run(async () => {
      const { label, modifiedOn } = data;
      const response = await accountService.contactCategories.delete({
        type: dependentType,
        label,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `Relationship was updated successfully.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        loadData();
      }
    });
  };

  return {
    relationships,
    isLoading,
    createRelationship,
    deleteRelationship,
    loadData,
  };
};
